import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Api from "../../Api";
import Fab from "../../parts/Fab";
import Section from "../../parts/Section";
import DiscreetMessage from "../../parts/DiscreetMessage";
import { User } from "../../types";

const UsersList = () => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<User[]>([]);
  const [results, setResults] = useState<User[]>([]);

  useEffect(() => {
    Api.usersGetAll()
      .then((users) => [setUsers(users), setResults(users)])
      .then(() => setLoading(false));
  }, []);

  const search = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    const filter = (user: User) =>
      [
        user.username.search(searchTerm) > -1,
        user.firstName.toLowerCase().search(searchTerm) > -1,
        user.lastName.toLowerCase().search(searchTerm) > -1,
      ].some((c) => c);
    setResults([...users.filter(filter)]);
  };

  return (
    <div>
      <div className="border-b">
        <Section className="py-4 px-8 flex">
          <input
            className="border rounded-full py-1 px-3 text-sm flex-1"
            placeholder="Buscar usuário"
            onChange={search}
            autoFocus
          />
        </Section>
      </div>

      <Section className="p-4">
        {loading && <DiscreetMessage text="Carregando ..." />}

        {!loading && (
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-4 pb-32">
              {results.length > 0 && results.map(UserCard)}

              {results.length === 0 && (
                <DiscreetMessage text="Nenhum resultado" />
              )}
            </div>

            <Fab href="/usuarios/criar" />
          </div>
        )}
      </Section>
    </div>
  );
};

export default UsersList;

const UserCard = (user: User) => (
  <Link
    className="border rounded-lg p-4 shadow-sm hover:bg-slate-50"
    to={`/usuarios/${user.uuid}`}
    key={user.uuid}
  >
    <div className="flex gap-2 items-center">
      <div className="font-semibold flex-1 whitespace-nowrap overflow-scroll no-scrollbar">
        {user.firstName} {user.lastName}
      </div>
      {user.active ? (
        <div className="text-xs font-mono rounded-full py-0.5 px-2 bg-green-100 text-green-700">
          {user.username}
        </div>
      ) : (
        <div className="text-xs font-mono rounded-full py-0.5 px-2 bg-red-100 text-red-700">
          {user.username}
        </div>
      )}
    </div>
  </Link>
);
